import { useEffect, useState } from 'react';
import facesRound from '../assets/faces-round.png';
import './logos.css';

function Logos({ widthOverride, heightOverride }) {
  const [logoUrl, setLogoUrl] = useState('');
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [width, setWidth] = useState(widthOverride);
  // eslint-disable-next-line no-unused-vars
  const [height, setHeight] = useState(heightOverride);

  useEffect(() => {
    const logoBase =
      'https://faces-drm-account-images.s3.us-east-1.amazonaws.com/profiles/';
    if (localStorage.getItem('facesAccountID')) {
      setLogoUrl(
        `${logoBase}${localStorage.getItem('facesAccountID')}.png?ver${Math.random()}`
      );
      setLoading(false);
    } else {
      const hostname = window.location.hostname; // e.g. "acct.example.com" or "acct.localhost"
      const parts = hostname.split('.');
      let subdomainAccountId = "";

      if (parts[0] === "e" || parts[0] === "localhost") {
        console.log("Setting logo url to defaults")
        setLogoUrl(null);// no usable subdomain
      } else {
        subdomainAccountId = parts[0];
      }

      // If we have a real subdomain account id, prefer it and refresh cache
      if (subdomainAccountId) {
        console.log('Subdomain account ID', subdomainAccountId);
        setLogoUrl(`${logoBase}${subdomainAccountId}.png?ver=${Math.random()}`);
        setLoading(false);
        return;
      }
      setLoading(false);
    }
  }, []);

  if (loading) return null;

  return (
    <div className="logos-row">
      <img
        style={{
          ...(height ? { height: height } : {}),
          ...(width ? { width: width } : {}),
        }}
        src={`${logoUrl || facesRound}`}
        alt=""
        onError={(e) => {
          if (e.target.src !== facesRound) {
            e.target.src = facesRound;
          }
        }}
        className="login-logos"
      />
    </div>
  );
}

export default Logos;
